import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AuthService from '../../../Services/authService';

export default class TpDataExportExcludedItemSearchParams extends SearchParamsBase {
  initialize() {
    this.TpDataExportExcludedItemId = '';
    this.EntityType = '';
    this.EntityId = '';
    this.Reason = '';
    this.AdditionalInformation = '';
    this.ThirdPartyInstanceName = '';
    this.Status = 'Active';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'TpDataExportExcludedItemId',
      label: 'TpDataExportExcludedItemId',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartyInstanceName',
      label: 'ThirdPartyInstanceName',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'EntityType',
      label: 'EntityType',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: TpDataExportExcludedItemSearchParams.getSelectOptionsForEntityType(),
    },
    { fieldName: 'EntityId', label: 'EntityId', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'AdditionalInformation',
      label: 'Additional Information',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'Reason', label: 'Reason', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: TpDataExportExcludedItemSearchParams.getSelectOptionsForStatus(),
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpDataExportExcludedItemSearchParams';

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user.officeId;
  }

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }

  static getSelectOptionsForStatus() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      { label: 'Active', value: 'Active', disabled: false },
      { label: 'Ignored', value: 'Ignored', disabled: false },
      { label: 'Updated', value: 'Updated', disabled: false },
      { label: 'Active & Updated', value: 'ActiveAndUpdated', disabled: false },
    ];
  }

  static getSelectOptionsForEntityType() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      { label: 'Evaluator', value: 'Evaluator', disabled: false },
      { label: 'TpJob', value: 'TpJob', disabled: false },
    ];
  }
}
